import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconStorybook32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconStorybook32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m20.604 6.95.12-2.71-.01-.02-13.2.83a1.2 1.2 0 0 0-1.13 1.27l.75 19.8a1.2 1.2 0 0 0 1.15 1.16l16.1.72a1.2 1.2 0 0 0 1.26-1.2V5.2a1.2 1.2 0 0 0-1.28-1.2l-1.33.1.1 2.76a.18.18 0 0 1-.28.14l-.9-.7-1.06.8a.18.18 0 0 1-.29-.15m-2.95 6.356V13.3v.01zm3.59-.086c-.428.319-3.565.548-3.59.085.059-1.795-.74-1.865-1.19-1.865-.41 0-1.13.13-1.13 1.1 0 .975 1.04 1.525 2.261 2.17 1.737.918 3.839 2.03 3.839 4.83 0 2.69-2.18 4.18-4.97 4.18-2.87 0-5.37-1.17-5.1-5.2.12-.48 3.77-.36 3.77 0-.05 1.67.34 2.16 1.3 2.16.73 0 1.05-.4 1.05-1.1 0-1.033-1.084-1.64-2.33-2.34-1.686-.947-3.67-2.061-3.67-4.62 0-2.57 1.75-4.29 4.9-4.29 3.14 0 4.86 1.69 4.86 4.89"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconStorybook32);
